export enum AirDeviceCreateMethod {
  menually = 1,
  automatedAccount = 2,
}

export default AirDeviceCreateMethod;
